import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const Material = ({ material }: SpecProps<"material">) => {
  const { i18n } = useLingui();

  if (material == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.material",
    message: "Material",
    comment: "Field for 'material' in ad specification",
  });
  return <FieldValuePair field={field} value={material} />;
};
